/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';
import classNames from 'classnames';
import { Collapse } from 'react-bootstrap/';
import DOMPurify from 'dompurify';
import { labels } from '@umati/dashboard-common';
import { connect } from 'react-redux';
import { setSoftwareFavourite, setSoftwareFavouriteType } from 'redux/actions';
import { ISoftware } from '@umati/dashboard-types';
import FrontendURLs from 'utilities/FrontendURLs';
import { Link } from 'react-router-dom';

interface ISoftwareListElementProps extends ISoftware {
  fairTag: string;
  cb: {
    expand: () => void;
  };
  in?: boolean;
}

interface ISoftwareListElementActions {
  setSoftwareFavourite: setSoftwareFavouriteType;
}

interface ISoftwareListElementAll extends ISoftwareListElementProps, ISoftwareListElementActions {}

class SoftwareListElement extends Component<ISoftwareListElementAll> {
  handeExpand = (e) => {
    e.stopPropagation();
    this.props.cb.expand();
  };

  handleLink = (e) => {
    e.stopPropagation();
  };

  render() {
    return (
      <li className="list-group-item" id={this.props.SoftwareId}>
        <div className="list-group-item-link" onClick={this.handeExpand}>
          <div className="row align-items-center" id={this.props.name?.replace(/\s+/g, '')}>
            <div className="col">
              {/* toggle "online" class to change status */}
              <span className="icon-software" title={labels.connectionInfo} />
              <h4>
                <Link
                  onClick={this.handleLink}
                  to={FrontendURLs.getSoftware(this.props.SoftwareId, this.props.fairTag)}
                >
                  {this.props.name}
                </Link>
              </h4>
              <div className="row list-group-item-data">
                <div className="col-12 col-sm-6">
                  <b>{labels.manufacturer}</b>
                  <a onClick={this.handleLink} href={this.props.manufacturerURL}>
                    {this.props.Data.Manufacturer.text}
                  </a>
                </div>
                <div className="col-12 col-sm-6">
                  <b>{labels.softwareWebpage}</b>
                  <a onClick={this.handleLink} href={this.props.demoPageUrl}>
                    {this.props.demoPageShortUrl}
                  </a>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <button
                className={classNames('btn-favorite', { active: this.props.Favorite })}
                value={0}
                title={labels.markAsFavorite}
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.setSoftwareFavourite(this.props.SoftwareId, !this.props.Favorite);
                }}
              />
            </div>
          </div>
        </div>
        <Collapse in={this.props.in}>
          <div className="list-group-item">
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.description) }}></div>
          </div>
        </Collapse>
      </li>
    );
  }
}

export default connect(null, { setSoftwareFavourite })(SoftwareListElement);
